module.exports = __webpack_public_path__ + "img/NCB.c3e36ab3.svg";